<template>
  <div
    :key="tabs.length"
    class="dashboard-tabs-container">
    <div
      v-show="tabs?.length > 1"
      class="dashboard-tabs is-hidden-mobile">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        :class="{ active: currentTab === tab.id }"
        class="tab"
        @click="selectTab(tab.id)">
        <div
          v-if="tab.icon"
          class="icon-container">
          <i class="material-icons">{{ tab.icon }}</i>
        </div>
        <div class="tab-label">
          {{ tab.label }}
        </div>
      </div>
    </div>
    <b-dropdown
      v-model="currentTab"
      class="mobile-dropdown is-hidden-tablet">
      <template #trigger>
        <div class="dropdown-trigger px-5">
          <div class="mobile-section-label">
            <!-- <span class="secondary-label"> Section </span> -->
            <div class="tab-label">
              {{ getCurrentTabLabel() }}
            </div>
          </div>

          <i class="material-icons">arrow_right</i>
        </div>
      </template>

      <b-dropdown-item
        v-for="(tab, i) in tabs"
        :key="i"
        :value="tab.id">
        <div class="dropdown-item-content">
          <!-- <i
            v-if="tab.icon"
            class="material-icons">{{ tab.icon }}</i> -->
          <span>{{ tab.label }}</span>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
  export default {
    props: {
      tabs: {
        type: Array,
        default: () => [],
      },

      value: {
        type: String,
        default: '',
      },
    },
    data () {
      return {}
    },
    computed: {
      currentTab: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
    },

    methods: {
      selectTab (tab) {
        this.currentTab = tab
      },
      getCurrentTabLabel () {
        const currentTab = this.tabs.find((tab) => tab.id === this.currentTab)
        return currentTab ? currentTab.label : 'Select Tab'
      },
      getCurrentTabIcon () {
        const currentTab = this.tabs.find((tab) => tab.id === this.currentTab)
        return currentTab ? currentTab.icon : null
      },
    },
  }
</script>
<style lang="scss" scoped>
::v-deep .dropdown-content {
  overflow: hidden;
}

.dashboard-tabs-container {
  padding: 8px;
  background-color: #F5F5F5;

  @include mobile {
    padding: 0;
  }
}

.dashboard-tabs {
  display: flex;
  width: 100%;
  gap: 8px;
}

.tab {
  width: 100%;
  background-color: $ui-09;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;

  height: 47px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  font-weight: 300;
  cursor: pointer;

  &:hover {
    background-color: $ui-08;
    border: 1px solid #7e7d84 !important;
    .icon-container {
      background-color: #504F54;
    }
  }
  &.active {
    background-color: #28272b;
    .icon-container {
      background-color: #504F54;
    }
    color: white;
  }
}

.icon-container {
  display: flex;
  align-items: center;
  height: 100%;
  width: 38px;
  justify-content: center;
  background-color: #7E7D84;
  i {
    font-size: 16px;
    color: white;
  }
}

.tab-label {
  padding-left: 10px;
  @include mobile {
    padding: 0;
  }
}

.mobile-dropdown {
  width: 100%;
  border-top: 1px solid #d2d2d4;
  border-bottom: 1px solid #d2d2d4;
  :deep(.dropdown-item.is-active) {
    background-color: rgb(233, 233, 234);
    color: rgb(74, 74, 74);
  }

  .dropdown-trigger {
    width: 100%;
    font-weight: 500;
    display: flex;
    align-items: center;
    padding: 5px 10px;
    background-color: black;
    color: white;
    .mobile-section-label {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 40px;
      justify-content: center;

      .secondary-label {
        font-size: 12px;
        font-weight: 300;
        color: $grayscale-4;
      }
    }
    .tab-label {
      font-size: 16px;
      width: 100%;
      align-items: center;
      font-weight: 400;
    }

    i {
      font-size: 22px;
      color: $grayscale-4;
    }
  }

  .dropdown-item-content {
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
    }
  }
}
</style>
